import Vue from 'vue'
import numberFormat from 'locutus/php/strings/number_format'

const NumberWonFormatPlugin = {
    install () {
        Vue.prototype.$_getWon = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            if (parseFloat(number) < 0) {
                return '-￦ ' + numberFormat(Math.abs(number), decimalPoint)
            } else {
                return '￦ ' + numberFormat(number, decimalPoint)
            }
        }
    }
}

const NumberDollarFormatPlugin = {
    install () {
        Vue.prototype.$_getDollar = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            if (parseFloat(number) < 0) {
                return '-$ ' + numberFormat(Math.abs(number), decimalPoint)
            } else {
                return '$ ' + numberFormat(number, decimalPoint)
            }
        }
    }
}

const NumberRatioFormatPlugin = {
    install () {
        Vue.prototype.$_getRatio = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            return `${numberFormat(number, decimalPoint).toString()} %`
        }
    }
}

const NumberAmountFormatPlugin = {
    install () {
        Vue.prototype.$_getAmount = (number, type, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            if (type.indexOf('DataTransfer') > -1) {
                return `${numberFormat(number, decimalPoint)} GB`
            } else if (type != null && type.indexOf('Requests') > -1) {
                return `${numberFormat(number, 0)} Requests`
            } else {
                return numberFormat(number, decimalPoint)
            }
        }
    }
}

const NumberFormatPlugin = {
    install () {
        Vue.prototype.$_getNumberFormat = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            return numberFormat(number, decimalPoint)
        }
    }
}

const StringCapitalizePlugin = {
    install () {
        Vue.prototype.$_getCapitalize = (text) => {
            return text.replace(/^./, text[0].toUpperCase())
        }
    }
}

// MZC Plugin Registration
Vue.use(NumberWonFormatPlugin)
Vue.use(NumberDollarFormatPlugin)
Vue.use(NumberRatioFormatPlugin)
Vue.use(NumberAmountFormatPlugin)
Vue.use(NumberFormatPlugin)
Vue.use(StringCapitalizePlugin)
